import { Separator } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function SeparatorDemo() {
  return (
    <Section
      id="separator"
      title="Separator"
      description="Visual divider. Horizontal or vertical."
    >
      <VariantBlock label="Horizontal">
        <div className="w-full max-w-md">
          <div className="text-sm font-medium">Theme settings</div>
          <p className="text-sm text-muted-foreground">
            Manage your interface preferences.
          </p>
          <Separator className="my-4" />
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span>Last edited 2026-05-24</span>
            <Separator orientation="vertical" className="h-4" />
            <span>v0.1.0</span>
          </div>
        </div>
      </VariantBlock>

      <VariantBlock label="Inline (decorative)">
        <span>foo</span>
        <Separator orientation="vertical" className="h-5" />
        <span>bar</span>
        <Separator orientation="vertical" className="h-5" />
        <span>baz</span>
      </VariantBlock>
    </Section>
  );
}
